export const channelWithoutProgramsPath = (includePrograms = false) => `/channel?includePrograms=${includePrograms}`;
